<template>
	<aside class="moment-timeline">
		<div class="timeline-header">
			<h3>时间轴</h3>
			<p>按日期查看动态</p>
		</div>
		<div class="timeline-scroll">
			<button class="timeline-item all" :class="{active: !selectedDate}" @click="$emit('select', '')">
				<span class="dot"></span>
				<span class="date">全部</span>
				<span class="count">{{ totalCount }}</span>
			</button>
			<button
				v-for="item in items"
				:key="item.date"
				class="timeline-item"
				:class="{active: isActive(item.date)}"
				@click="$emit('select', item.date)">
				<span class="dot"></span>
				<span class="date">{{ item.date }}</span>
				<span class="count">{{ item.count }}</span>
			</button>
		</div>
	</aside>
</template>

<script>
export default {
	name: 'MomentTimeline',
	props: {
		items: {
			type: Array,
			default: () => []
		},
		selectedDate: {
			type: String,
			default: ''
		},
		activeDate: {
			type: String,
			default: ''
		}
	},
	computed: {
		totalCount() {
			return this.items.reduce((sum, item) => sum + Number(item.count || 0), 0)
		}
	},
	methods: {
		isActive(date) {
			if (this.selectedDate) {
				return this.selectedDate === date
			}
			return this.activeDate === date
		}
	}
}
</script>

<style scoped>
.moment-timeline {
	position: sticky;
	top: 70px;
	align-self: flex-start;
	width: 280px;
	max-height: calc(100vh - 100px);
	overflow: hidden;
	padding: 14px 14px 10px;
	border-radius: 16px;
	background: linear-gradient(180deg, #f8fbff 0%, #ffffff 100%);
	border: 1px solid #e8eef5;
	box-shadow: 0 10px 24px rgba(15, 23, 42, .06);
}

.timeline-header h3 {
	margin: 0;
	font-size: 16px;
	font-weight: 700;
	color: #1f2937;
}

.timeline-header p {
	margin: 4px 0 10px;
	font-size: 12px;
	color: #6b7280;
}

.timeline-scroll {
	position: relative;
	max-height: calc(100vh - 180px);
	overflow: auto;
	padding-left: 2px;
}

.timeline-scroll::before {
	content: '';
	position: absolute;
	left: 10px;
	top: 8px;
	bottom: 8px;
	width: 2px;
	background: linear-gradient(180deg, #dbeafe 0%, #bfdbfe 50%, #dbeafe 100%);
}

.timeline-item {
	width: 100%;
	display: grid;
	grid-template-columns: 20px 1fr auto;
	align-items: center;
	gap: 8px;
	padding: 8px 10px 8px 0;
	border: 0;
	background: transparent;
	cursor: pointer;
	border-radius: 10px;
	text-align: left;
	transition: background .2s ease, transform .2s ease;
}

.timeline-item:hover {
	background: rgba(37, 99, 235, .08);
	transform: translateX(2px);
}

.timeline-item .dot {
	width: 10px;
	height: 10px;
	margin-left: 6px;
	border-radius: 50%;
	background: #93c5fd;
	box-shadow: 0 0 0 4px rgba(147, 197, 253, .15);
	transition: all .2s ease;
}

.timeline-item .date {
	font-size: 13px;
	color: #334155;
	white-space: nowrap;
}

.timeline-item .count {
	min-width: 20px;
	height: 20px;
	padding: 0 6px;
	line-height: 20px;
	text-align: center;
	border-radius: 999px;
	background: #f1f5f9;
	font-size: 12px;
	color: #475569;
}

.timeline-item.active {
	background: linear-gradient(90deg, rgba(37, 99, 235, .12), rgba(59, 130, 246, .05));
}

.timeline-item.active .dot {
	background: #2563eb;
	box-shadow: 0 0 0 5px rgba(37, 99, 235, .18), 0 0 10px rgba(37, 99, 235, .35);
	transform: scale(1.08);
}

.timeline-item.active .date {
	color: #1d4ed8;
	font-weight: 600;
}

.timeline-item.active .count {
	background: #2563eb;
	color: #fff;
}

@media (max-width: 992px) {
	.moment-timeline {
		position: static;
		width: 100%;
		max-height: none;
		padding: 10px;
		border-radius: 12px;
		margin-top: 12px;
	}

	.timeline-header {
		margin-bottom: 6px;
	}

	.timeline-scroll {
		display: flex;
		gap: 8px;
		max-height: none;
		overflow-x: auto;
		overflow-y: hidden;
		padding: 2px 0;
	}

	.timeline-scroll::before {
		display: none;
	}

	.timeline-item {
		flex: 0 0 auto;
		display: inline-flex;
		align-items: center;
		gap: 6px;
		border: 1px solid #dbeafe;
		padding: 6px 8px;
		border-radius: 999px;
	}

	.timeline-item .dot {
		margin-left: 0;
		width: 8px;
		height: 8px;
		box-shadow: none;
	}
}
</style>
